(function ($, undefined) {
    "use strict";

    var info = document.createElement('span');
    var info_text = document.createTextNode("ID: ");
    info.appendChild(info_text);
    info.className = "badge badge-secondary"

    $.jstree.plugins.nodeIds = function (options, parent) {
        this.teardown = function () {
            this.element.find(".jstree-nodeIds").remove();
            parent.teardown.call(this);
        };
        this.redraw_node = function (obj, deep, callback, force_draw) {
            obj = parent.redraw_node.call(this, obj, deep, callback, force_draw);
            if (obj) {
                var tmp = info.cloneNode(true);
                tmp.childNodes[0].appendData(" " + obj.id);
                obj.childNodes[1].appendChild(tmp);
            }
            return obj;
        };
    };
})(jQuery);


;(function($, window, document, undefined) {
    var pluginName = "fixtree",
        defaults = {
            loadFirstRoot: true,
            withContextMenu: true,
            rootDisplay: "select",
            controller: "/tree",
            actions: {
                operation: "/operation",
                roots: "/roots",
                children: "/children",
                subtree: "/subtree"
            },
            jsTree: {
                core : {
                    animation: 0,
                    check_callback: function (operation, node, node_parent, node_position, more) {
                        // operation can be 'create_node', 'rename_node', 'delete_node', 'move_node', 'copy_node' or 'edit'
                        // in case of 'rename_node' node_position is filled with the new node name
                        console.log(node);
                        if(operation === "delete_node" && !confirm("Wirklich " + node.text + "(" + node.id + ") löschen?")) {
                            return false;
                        }
                        return true;
                    },
                    themes: { stripes: true },
                    data: function (node) {
                        return { id: node.id };
                    }
                },
                types : {
                    "CART_PRODUCT" : {
                        "icon" : "fa fa-shopping-cart"
                    },
                    "DISPLAY_PRODUCT" : {
                        "icon" : "fa fa-eye"
                    },
                    "TYPE" : {
                        "icon" : "fa fa-object-group"
                    },
                    "PROVIDER" : {
                        "icon" : "fa fa-building-o"
                    }
                },
                plugins: [
                    "dnd", "search", "nodeIds",
                    "state", "types"
                ]
            }
        };

    function FixTree(element, options) {
        this.element = $(element);
        this.settings = $.extend(true, {}, defaults, options);

        this._defaults = defaults;
        this._name = pluginName;

        this.elements = {
            tree: null,
            toolbar: null,
            breadcrumb: null
        };

        if (this.settings.withContextMenu) {
            this.settings.jsTree.plugins.push("contextmenu");
        }

        this.init();
        
        return this;
    }

    $.extend(FixTree.prototype, {
        init: function () {
            var that = this;

            that.element.addClass("fixtree");
            that.elements.tree = that.element.find(".jstree");
            that.elements.toolbar = that.element.find(".fixtree-toolbar");
            that.elements.breadcrumb = that.element.find(".fixtree-breadcrumb");
            
            var rootspanel = that.elements.toolbar.find(".fixtree-roots");

            if (rootspanel) {
                that.elements.toolbar.find(".fixtree-add-root").find("button").click(function() {
                    var text = $(this).parents(".fixtree-add-root").find("input").val();
                    $(this).parents(".fixtree-add-root").find("input").val("");
                    if (text.length > 0) {
                        $.get(that.settings.controller + that.settings.actions.operation + '?operation=create_root', { 'text' : text })
                            .done(function (d) {
                                if (d.id) {
                                    that.initRoots(d.id);
                                }
                            })
                            .fail(function () {

                            });
                    }
                });
            }

            that.elements.toolbar.find(".tree-refresh-button").click(function() {
                $(this).parents(".fixtree").find(".jstree").jstree().refresh();
            });
            
            that.elements.toolbar.find(".tree-search").find("input").keyup(function() {
                $(this).parents(".fixtree").find(".jstree").jstree().search($(this).val());
            });
            
            if (that.elements.breadcrumb) {
                that.element.find('.fixtree-toggle').click(function() {
                    that.elements.tree.toggle(100);
                });
            }

            that.initRoots();

            return that;
        },
        initRoots: function(preselected) {
            var that = this;
            var rootspanel = that.elements.toolbar.find(".fixtree-roots");

            switch (that.settings.rootDisplay) {
                default:
                case 'select':
                    if (rootspanel) {
                        $.getJSON(that.settings.controller + that.settings.actions.roots, function(roots) {
                            rootspanel.find('select').remove();
                            var select = $("<select class=\"form-control chosen-select\" />")
                                .change(function() {
                                    that.changeTree($(this).val());
                                })
                                .appendTo(rootspanel);
                            for (var i = 0; i < roots.length; i++) {
                                select.append(
                                    $("<option />")
                                        .text(roots[i].text)
                                        .attr("value", roots[i].id)
                                );
                            }

                            if (preselected != undefined) {
                                select.val(preselected);
                                that.changeTree(preselected);
                            } else if (that.settings.loadFirstRoot) {
                                that.changeTree(roots[0].id);
                            }
                        });
                    }
                    break;
                case 'buttons':
                    $.getJSON(that.settings.controller + that.settings.actions.roots, function(roots) {
                        rootspanel.find('buttons').remove();
                        for (var i = 0; i < roots.length; i++) {
                            if (rootspanel) {
                                $("<button class=\"btn btn-outline-secondary\" type=\"button\" />")
                                    .text(roots[i].text)
                                    .attr("root-id", roots[i].id)
                                    .click(function() {
                                        that.changeTree($(this).attr('root-id'));
                                    })
                                    .appendTo(rootspanel);
                            }
                        }
                        if (preselected != undefined) {
                            that.changeTree(preselected);
                        } else if (that.settings.loadFirstRoot) {
                            that.changeTree(roots[0].id);
                        }
                    });
                    break;
            }
        },
        changeTree: function(rootId) {
            var that = this;
            if (that.elements.tree.children().length > 0) {
                that.elements.tree.jstree().destroy();
            }
            
            var cb_subtree = that.settings.controller + that.settings.actions.subtree,
                cb_children = that.settings.controller + that.settings.actions.children;
            that.settings.jsTree.core.data.url = function(node) {
                return node.id === '#' ? cb_subtree + '/' + rootId : cb_children;
            };
            
            that.initTree();
        },
        initTree: function () {
            var that = this;

            that.elements.tree.jstree(that.settings.jsTree)
            .on('delete_node.jstree', function (e, data) {
                $.get(that.settings.controller + that.settings.actions.operation + '?operation=delete_node', { 'id' : data.node.id })
                    .fail(function () {
                        data.instance.refresh();
                    });
            })
            .on('create_node.jstree', function (e, data) {
                $.get(that.settings.controller + that.settings.actions.operation + '?operation=create_node', { 'id' : data.node.parent, 'position' : data.position, 'text' : data.node.text })
                    .done(function (d) {
                        data.instance.set_id(data.node, d.id);
                    })
                    .fail(function () {
                        data.instance.refresh();
                    });
            })
            .on('rename_node.jstree', function (e, data) {
                $.get(that.settings.controller + that.settings.actions.operation + '?operation=rename_node', { 'id' : data.node.id, 'text' : data.text })
                    .fail(function () {
                        data.instance.refresh();
                    });
            })
            .on('move_node.jstree', function (e, data) {
                $.get(that.settings.controller + that.settings.actions.operation + '?operation=move_node', { 'id' : data.node.id, 'parent' : data.parent, 'position' : data.position })
                    .fail(function () {
                        data.instance.refresh();
                    });
            })
            .on('copy_node.jstree', function (e, data) {
                $.get(that.settings.controller + that.settings.actions.operation + '?operation=copy_node', { 'id' : data.original.id, 'parent' : data.parent, 'position' : data.position })
                    .always(function () {
                        data.instance.refresh();
                    });
            })
            .on('set_text.jstree', function (e, data) {
                console.log('show_node');
                console.log(e);
            })
            .on('ready.jstree', function (e, data) {
                data.instance.select_node('ul > li:first');
            })
            .on('changed.jstree', that.onChanged)
            .on('select_node.jstree', that.selectNode);
        },
        breadcrumb: function (e, data) {
            var that = this;
            if (that.elements.breadcrumb) {
                if (data.selected.length == 1) {
                    that.elements.breadcrumb.empty();

                    var s = data.instance.get_node(data.selected[0], true);
                    
                    s.parents("li").each(function() {
                        var treeLink = $(this).children("a");
                        $("<li class='breadcrumb-item' />")
                            .append(
                                $("<a href='#' />").text(treeLink.text()).click(function() {treeLink.click();})
                            ).prependTo(that.elements.breadcrumb);
                    });
                    $("<li class='breadcrumb-item active' />").text(s.children("a").text())
                        .appendTo(that.elements.breadcrumb);
                    
                    if (!s.hasClass('jstree-leaf')) {
                        data.instance.open_node(s, function(node) {
                            var node = data.instance.get_node(node, true);
                            
                            $("<li class='breadcrumb-item active' />").append(
                                $('<div class="btn-group" />')
                                    .append(
                                        $('<button class="btn btn-secondary dropdown-toggle" style="position:absolute; top: -1.1rem" type="button" data-toggle="dropdown" />')
                                            .text('Untergruppen ')
                                            .append($('<span class="caret"></span>)'))
                                    )
                                    .append($('<div class="dropdown-menu fixtree-children" role="menu" />'))
                            ).appendTo(that.elements.breadcrumb);
                            
                            var children = that.elements.breadcrumb.find('.fixtree-children');
                            
                            node.find('> ul > li > a').each(function() {
                                var treeLink = $(this);
                                children.append(
                                    $('<a class="dropdown-item" href="#" />').text(treeLink.text()).click(function() {treeLink.click();})
                                );
                            });
                        });
                    }
                }
            }
            return that;
        },
        onChanged: function (e, data) {
            $(this).parents('.fixtree').fixtree().breadcrumb(e,data);
        },
        selectNode: function (e, data) {
            $(this).parents('.fixtree').fixtree().onSelect(e, data);
        },
        onSelect: function(e, data) {
            //console.log('onSelect');
        }
    });

    $.fn[pluginName] = function(options) {
        if (this.length == 1) {
            if (!$.data(this[0], "plugin_" + pluginName)) {
                $.data(this[0], "plugin_" + pluginName, new FixTree(this, options));
            }
            
            return $.data(this[0], "plugin_" + pluginName);
        } else {
            console.log("Fehler!");
        }
        return this;
    };
})(jQuery, window, document);
